module.exports = function(app) {
	app.filter('stringToDate', ['$filter', function($filter) {
		return function(stringDate, format) {
			if (stringDate.length === 8) {
				var pattern = /(\d{4})(\d{2})(\d{2})/;
				date = new Date(stringDate.replace(pattern, '$1-$2-$3'));
			}
			else {
				date = new Date(stringDate);
			}
			return $filter('date')(date, format, 'UTC');
		};
	}]);
};

